import React from 'react';
import { ArrowUp, Heart } from 'lucide-react';
import { getBrandFromVendor, isBrandActive } from '../../utils/vendorBranding';

const VendorHeaderInfo = ({
  vendor,
  brand: brandProp,
  isFavorited,
  onToggleFavorite,
  onShare,
  isLoading = false,
  isAuthenticated = false,
  hideTitle = false,
}) => {
  const brand = brandProp || getBrandFromVendor(vendor);
  const active = isBrandActive(brand);
  const showLogo = active && brand.show_logo_in_header !== false && brand.logo_url;
  const bannerMode = active && brand.hero_style === 'banner';

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="flex items-start justify-between gap-4">
        {!hideTitle && (
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2.5 sm:gap-3">
              {!bannerMode && showLogo && (
                <img
                  src={brand.logo_url}
                  alt=""
                  className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg object-cover border border-gray-200 flex-shrink-0"
                />
              )}
              <div className="min-w-0">
                {!bannerMode && (
                  <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-3xl font-light text-black leading-tight break-words">
                    {vendor?.business_name}
                  </h1>
                )}
                {brand?.tagline && !bannerMode && (
                  <p className="text-sm sm:text-base text-gray-600 font-light mt-1 leading-relaxed">
                    {brand.tagline}
                  </p>
                )}
              </div>
            </div>
          </div>
        )}

        <div className={`flex gap-4 sm:gap-6 flex-shrink-0 ${hideTitle ? 'ml-auto' : ''}`}>
          <button
            onClick={onShare}
            className="flex items-center gap-1.5 sm:gap-2 text-black hover:opacity-70 transition-opacity touch-manipulation"
            aria-label="Share vendor"
          >
            <ArrowUp className="w-4 h-4 sm:w-5 sm:h-5" />
            <span className="text-sm sm:text-base underline font-light">Share</span>
          </button>
          {isAuthenticated && (
            <button
              onClick={onToggleFavorite}
              disabled={isLoading}
              className="flex items-center gap-1.5 sm:gap-2 text-black hover:opacity-70 transition-opacity touch-manipulation disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
            >
              <Heart className={`w-4 h-4 sm:w-5 sm:h-5 transition-all ${isFavorited ? 'fill-current text-red-500' : ''} ${isLoading ? 'animate-pulse' : ''}`} />
              <span className="text-sm sm:text-base underline font-light">
                {isLoading ? 'Saving...' : 'Save'}
              </span>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorHeaderInfo;
